import { MealIngredient } from 'fitbeat.models';
import { IMealIngredientsRepository } from '../interfaces/imealingredients-repository';

export class DbMealIngredientsRepository implements IMealIngredientsRepository {
    constructor(private mealIngredientsDb: any) { }

    public async add(ingredient: MealIngredient): Promise<MealIngredient> {
        const doc = JSON.parse(JSON.stringify(ingredient));
        doc._id = ingredient._id;
        await this.mealIngredientsDb.put(doc);
        return ingredient;
    }

    public async get(uid: string): Promise<MealIngredient | undefined> {
        try {
            const ingredient = await this.mealIngredientsDb.get(uid);
            return Object.assign(new MealIngredient(), ingredient);
        } catch (err) {
            if (err.status === 404) {
                return undefined;
            } else {
                throw err;
            }
        }
    }

    public async getAll(): Promise<MealIngredient[]> {
        const results: any = await this.mealIngredientsDb.allDocs({
            include_docs: true,
        });
        const docs: any[] = results
            .rows
            .map((row: any) => row.doc)
            .filter((doc: any) => doc._id !== '0');

        const mealIngredients: MealIngredient[] = docs.map((doc: any): MealIngredient => {
            const returnObj: MealIngredient = Object.assign(new MealIngredient(), doc);
            return returnObj;
        });

        return mealIngredients;
    }

    public async update(ingredient: MealIngredient): Promise<MealIngredient> {
        const doc = JSON.parse(JSON.stringify(ingredient));
        await this.mealIngredientsDb.put(doc);
        return ingredient;
    }
}
